export default __webpack_public_path__ + "images/0222862ad71148fb344c321ce4714787-city_town.jpg";